export default {"src":"/planos/_next/static/media/4.0986500c.svg","height":65,"width":47,"blurWidth":0,"blurHeight":0};